export { AutoCleanedStrongCache, AutoCleanedWeakCache } from "./caches.js";
export { cacheSizes } from "./sizes.js";
//# sourceMappingURL=index.js.map